<template>
  <div class="videos bg-white h-full">

    <FilterBar @searchChanged="setSearchValue">
      <template v-slot:filter>
        <div>
          <Dropdown
            :options="typeDropdown"
            :selected="videoType"
            :title="'Video Type'"
            v-on:updateOption="updateVideoType"
            style="min-width: 10rem"
          >
            ></Dropdown
          >
        </div>
        <div>

        </div>
      </template>
    </FilterBar>

    <div v-if="errored" class="empty">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" v-else>
      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Videos</p>
      </div>

      <div v-else>
        <table
          class="
            w-95p
            mx-auto
            mb-2
            h-10
            pt-2
            align-text-bottom
            bg-white
            rounded
            text-left text-gray-600
          "
        >
          <thead class="bg-gray-100 w-full">
            <tr>
              <th class="w-6/12 pl-3">Title</th>
              <th class="w-5/12 pl-3">Tags</th>
              <th w-1>Action</th>
            </tr>
          </thead>
        </table>

        <table class="table-wrapper w-95p bg-white mx-auto rounded shadow-sm">
          <tbody>
            <tr v-for="(video, index) in filteredList" :key="video.id">
              <td class="w-6/12 font-semibold">{{ video.title }}</td>
              <td class="w-5/12">{{ parseTags(video.tags) }}</td>
              <td class="2u">
                <a
                  @click="display(video)"
                  class="button special small cursor-pointer"
                  v-if="shouldDisplay(index)"
                  >View</a
                >
                <i v-else class="fas fa-lock text-yellow-500 text-lg"></i>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="m-4 text-gray-500 pt-2 pl-5">
          Showing {{ filteredList.length }} videos
        </div>
      </div>
    </div>

    <modalvideo
      :url="loadVideoPath()"
      @close="showModalVideo = false"
      v-if="selectedVideo != undefined && showModalVideo"
      v-show="showModalVideo"
    ></modalvideo>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { BaseService } from "@/services/school.service";

const modalvideo = () => import("@/components/ModalVideo.vue");
const Dropdown = () => import("@/components/Dropdown.vue");
const FilterBar = () => import("@/components/FilterBarNavigation.vue");

export default {
  name: "videos",
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.videos.length > 0;
    },
    showLancs() {
      return this.currentUser.schoolStyle == "lancashire";
    },
    typeDropdown() {
      return this.typeList;
    },
    orderedVideos() {
      return _.orderBy(this.videos, ["title"]);
    },
    filteredList() {
      var vm = this;
      return this.orderedVideos.filter((item) => {
        let filtered = true;
        if (item.tags != null) {
          filtered = item.tags.toLowerCase().includes(vm.search.toLowerCase());
        }

        if (filtered) {
          if (item.title != null) {
            filtered = item.title
              .toLowerCase()
              .includes(vm.search.toLowerCase());
          }
        }

        return filtered;
      });
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      videos: [],
      selectedVideo: {},
      showModalVideo: false,
      search: "",
      typeList: [],
      videoType: "",
      currentTab: 0,
    };
  },
  created() {
    this.typeList = [
      { id: 1, value: "library", name: "PE Suite", tags: "pesuite" },
      { id: 2, value: "library", name: "Flexi Yoga", tags: "yoga" },
      { id: 3, value: "library", name: "Dance 4 Schools", tags: "motif" },
      { id: 4, value: "library", name: "Gymnastics", tags: "gym" },
      //{ id: 2, value: "warm-up", name: "Warm Ups" },
    ];

    this.videoType = this.typeList[0];
    this.fetchData();
  },
  mounted() {
    //this.fetchYears();
    if (this.showLancs) {
      this.typeList.push({ id: 5, value: "lancashire", name: "Lancashire" });
    }
  },
  methods: {
    fetchData() {
      this.loading = true;
      var value = "types=" + this.videoType.value
      if (this.videoType.tags != undefined) {
        value += "&tags=" + this.videoType.tags
      } 

      BaseService.getAll("videos?" + value)
        .then((response) => this.buildVideoList(response.data.data))
        .catch((err) => {
          console.log("Videos " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildVideoList(data) {
      this.videos = data;
    },
    display(video) {
      this.selectedVideo = video;
      this.showModalVideo = true;
    },
    loadVideoPath() {
      return this.selectedVideo.service_url_b;
    },
    setStyles(value) {
      return this.vid === value
        ? "bg-orange-300 text-white"
        : "bg-white text-gray-400";
    },
    checkTab(value) {
      return this.currentTab == value ? "active" : "";
    },
    showVideos(tab, cat) {
      this.typeSelected = "videos";
      this.currentTab = tab;
      this.videoType = cat;
    },
    updateVideoType(value) {
      this.videoType = value;
      this.fetchData()
    },
    setSearchValue(value) {
      this.search = value
    },
    parseTypeDisplay(value) {
      return value.toLowerCase()
    },
    parseTags(tags) {

      let tagList = tags.replace(/\s/g, "").split(',').map(function(t) {
            return " #" + t.toLowerCase()
      });
      return tagList.join(", ")
    },
    shouldDisplay(index) {
      if (index === 0) {
        return true
      } else if (this.currentUser.isOnTrial) {
        return false
      } else if (this.currentUser.isOnFree) {
        return this.currentAccess.resourceAccess
      } else {
        return this.currentUser.isSubscriber
      }
    }
  },
  components: {
    modalvideo,
    Dropdown,
    FilterBar,
  },
};
</script>

<style>
i.icon {
  font-size: 18px;
  padding-left: 4px;
  padding-top: 4px;
}
</style>
